import React from 'react';
import { useNavigate } from 'react-router-dom';
import './LuxuryPackages.css';
import PackageCard from './PackageCard';

const packages = [
  { title: 'Новые направления', placeCount: 47, image: 'package-1.png' },
  { title: 'Зимний отдых', placeCount: 34, image: 'package-2.png' },
  { title: 'Wellness-туры', placeCount: 29, image: 'package-3.png' },
  { title: 'Необычные места', placeCount: 29, image: 'package-4.png' },
  { title: 'Вдали от толпы', placeCount: 168, image: 'package-5.png' },
];

const LuxuryPackages = () => {
  const navigate = useNavigate();

  return (
    <section className="luxury-packages-section page-section">
      <div className="page-container">
        <div className="packages-header">
          <div>
            <h2 className="section-title packages-title">Премиальные пакеты</h2>
            <p className="section-subtitle packages-subtitle">
              Готовые подборки направлений — выберите категорию и посмотрите все предложения.
            </p>
          </div>
          <button className="btn-secondary" onClick={() => navigate('/packages')}>
            Смотреть все
          </button>
        </div>

        <div className="packages-grid">
          {packages.map((pkg) => (
            <PackageCard key={pkg.title} {...pkg} onClick={() => navigate('/packages')} />
          ))}
        </div>
      </div>
    </section>
  );
};

export default LuxuryPackages;
